import React, {useEffect, useRef, useState} from 'react';
import {
  calculateSumOfEachRow,
  calculateTotalSum,
  deleteRowHandler,
  updateTableCellHandler
} from "../SellFactor/SellFactorFunctions";
import tableCalc from "../../utils/tableCalc";
import {ReactTabulator} from "react-tabulator";
import tabulatorTableOptions from "../../utils/TabulatorTableOptions";
import {formatToPersianAddComma, parseToEnRemoveComma} from "../../utils/CommaSeparator";
import NewTabulator from "../NewTabulator/NewTabulator";

const SaleReturnTable = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {


  const [reload, setReload] = useState(false)
  useEffect(() => {
    setSendData({tableData: calculateSumOfEachRow(sendData.tableData)})
  }, [reload])


  const [sum, setSum] = useState(0);
  useEffect(() => {
    const newSum = isNaN(calculateTotalSum(sendData)) ? 0 : calculateTotalSum(sendData)
    setSum(newSum)
  }, [sendData])

  const tableColumns = [
    {
      title: "حذف", headerSort: false, formatter: "buttonCross", // width: 60,
      style:{display:'flex', justifyContent:'center' , alignItems:'center'},
      maxWidth: 100, headerHozAlign: "center", cellClick: function (e, cell) {
        console.log("حذف حذف حذف");
        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const tableData = deleteRowHandler(sendData.tableData, productId, storeId);
        setSendData({tableData});
        setReload(!reload)
      },
    },
    {title: "کد کالا", field: 'productId', visible: true,
      style:{display:'flex', justifyContent:'center' , alignItems:'center'},
    },
    {title: "نام کالا", field: 'productName',},
    {title: "گروه کالا", field: 'productGroup',
      style:{display:'flex', justifyContent:'center' , alignItems:'center'},
    },
    {title: "رنگ", field: 'productColor',
      style:{display:'flex', justifyContent:'center' , alignItems:'center'},
    },
    {title: "سایز", field: 'productSize',
      style:{display:'flex', justifyContent:'center' , alignItems:'center'},
    },
    {title: " کد انبار", field: "storeId", visible: false,},
    {title: "انبار", field: "storeName", visible: true,},
    {
      title: "قیمت", field: 'price', editor: "number", formatter: tableCalc.separateNumbers,
      editorParams: {
        min: 1, step: 1,
      },
      cellEdited: function (e, cell) {
        const value = parseToEnRemoveComma(e.target.value);

        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const tableData = updateTableCellHandler(sendData.tableData, productId, storeId, "price", value);
        setSendData({tableData})
        setReload(!reload)

      }
    },
    {
      title: "تعداد", field: 'number', editor: "number", formatter: tableCalc.separateNumbers,

      bottomCalc: tableCalc.sum,
      cellEdited: function (e, cell) {
        const value = parseToEnRemoveComma(e.target.value);
        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const tableData = updateTableCellHandler(sendData.tableData, productId, storeId, "number", value);
        setSendData({tableData})
        setReload(!reload)
      }
    },
    {
      title: "جمع کل", field: "total", bottomCalc: tableCalc.sum,
      style:{display:'flex', justifyContent:'center' , alignItems:'center' , overflow:'hidden'},
    },

    {title: "  آدی موجودی", field: "inventoryId", visible: false,},
    {title: "آدی جزء", field: "particleFactorId", visible: false,},
    {field: "recordId", visible: false,},


  ];


  return (
    <div className="separate-factor__newSellComponent"
      // ref={seperateFac}
    >
      <NewTabulator
        columns={tableColumns}
        data={sendData.tableData}
        options={tabulatorTableOptions.tableOptions}
        style={{height: "70vh"}}
        className={"header__color__F1F1F1"}


      />

      {/*<ReactTabulator*/}
      {/*  ref={tableRef}*/}
      {/*  columns={tableColumns}*/}
      {/*  // data={dataEdit.main !== undefined ? dataEdit.particle.data : [] }*/}
      {/*  data={sendData.tableData}*/}
      {/*  // dataChanged={(newData) => console.log("dataChanged", newData)}*/}
      {/*  options={tabulatorTableOptions.tableOptions}*/}
      {/*  style={{height: "70vh"}}*/}

      {/*/>*/}
      <div> جمع کل : {formatToPersianAddComma(sum)}</div>

    </div>
  );
};

export default SaleReturnTable;
